export default __webpack_public_path__ + "static/media/krandom1k.7130d163.png";